import { render, staticRenderFns } from "./vsDropDownItem.vue?vue&type=template&id=0fb0319c&lang=html&"
import script from "./vsDropDownItem.vue?vue&type=script&lang=js&"
export * from "./vsDropDownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsDropDownItem.vue"
export default component.exports